import { Action, createReducer, on } from '@ngrx/store';
import * as timePickerActions from './actions';
import { TimePickerState } from './state';

export const initialTimePickerState: TimePickerState = {
  errors: null,
  quantity: 1,
};

const timePickerReducers = createReducer(
  initialTimePickerState,
  on(
    timePickerActions.SetTimePickerValues,
    (
      state,
      {
        start,
        end,
        availabilityPlanId,
        recurrenceFreq,
        quantity,
        preparationMinutes,
        followUpMinutes,
      },
    ) => ({
      ...state,
      startDate: start,
      endDate: end,
      availabilityPlanId,
      recurrenceRule: recurrenceFreq,
      quantity: quantity ?? null,
      preparationMinutes,
      followUpMinutes,
    }),
  ),
  on(timePickerActions.SetStartDate, (state, { startDate }) => ({ ...state, startDate })),
  on(timePickerActions.SetEndDate, (state, { endDate }) => ({ ...state, endDate })),
  on(timePickerActions.SetAvailabilityPlanId, (state, { availabilityPlanId }) => ({
    ...state,
    availabilityPlanId,
  })),
  on(timePickerActions.SetQuantity, (state, { quantity }) => ({ ...state, quantity })),
  on(timePickerActions.SetPreparationMinutes, (state, { minutes }) => ({
    ...state,
    preparationMinutes: minutes,
  })),
  on(timePickerActions.SetFollowUpMinutes, (state, { minutes }) => ({
    ...state,
    followUpMinutes: minutes,
  })),
  on(timePickerActions.SetRecurrenceFreq, (state, { recurrenceFreq }) => ({
    ...state,
    recurrenceRule: recurrenceFreq,
  })),
  on(timePickerActions.SetTimePickerErrors, (state, { errors }) => ({ ...state, errors })),
);

export function reducers(state: TimePickerState | undefined, action: Action): TimePickerState {
  return timePickerReducers(state, action);
}
